import React, { Component } from 'react';
import './patients.css';
import { AppHeader } from '../base-components';
import moment from 'moment-timezone';
import { nextArrow, logo, addBtn, profileOptsBg, photoPlaceholder } from '../assets';
import { Link } from 'react-router';
import { fonts, colors } from '../styleguide';
import { strings as _strings } from '../lib';
const strings = _strings.patientList;

const styles = {
  link: {
    fontFamily: "Helvetica Neue, Helvetica, Arial, sans-serif",
    fontSize: 16,
    color: 'black',
    textDecoration: 'none'
  },
  docContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 40
  },
  profilePic: {
    width: 40,
    height: 40,
    borderRadius: 20,
    marginLeft: 10
  },
  zeroMargin: {
    margin: 0
  },
  opts: {
    display: 'flex',
    flex: 1,
    position: 'absolute',
    right: 12,
    top: 35
  },
  optsBg: {
    left: 0,
    right: 0,
    top: 0,
    bottom:0
  },
  logoutBtn: {
    position: 'absolute',
    left: 20,
    right: 20,
    top: 26,
    bottom: 20,
    textAlign: 'center',
    color: colors.clickarisePurple
  }
};

export default class Patients extends Component {

  static propTypes = {
    patients: React.PropTypes.any, //TODO: use immutable prop tpyes
    user: React.PropTypes.any, //TODO: use immutable prop tpyes
    onLogout: React.PropTypes.func.isRequired
  };
  
  constructor(props) {
    super(props);

    this.state = {
      showProfileOptions: false,
      addBtnExpanded: false
    };
  }
  
  render() {
    const { patients } = this.props;
    return (
      <div className="ps-container">
        <AppHeader renderRightItem={this.renderDoc}/>
        <div className="nav-header">
          {this.renderTab(strings.patientsTab)}
        </div>
        <div className="ps-content-container">
          <div className="list-container">
            {this.renderListHeader()}
            {patients.map( this.renderPatient )}
          </div>
          <Link to={`/patients/new`}>
            <div className="add-btn"
                 style={{ width: this.state.addBtnExpanded ? 240 : 60 }}
                 onMouseEnter={() => this.setState({ addBtnExpanded: true })}
                 onMouseLeave={() => this.setState({ addBtnExpanded: false })}>
              <img src={addBtn} />
              {this.state.addBtnExpanded ? (
                  <p style={{
                    fontSize: 16,
                    fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                    color: '#000000',
                    marginLeft: 10
                  }}>Add a new patient</p>
              ) : null}
            </div>
          </Link>
        </div>
      </div>
    );
  }

  renderPatient(patient) {
    const patientId = patient.get('id');
    const isEnrolled = !!patientId;
    return (
      <div className="patient-row"
           style={{ backgroundColor: isEnrolled ? 'white' : '#F7F7F7', opacity: isEnrolled ? 1 : 0.2 }}>
        <div className="name-container">
        <p className="patient-row-name">{patient.get('firstName') + ' ' + patient.get('lastName')}</p>
        </div>
        <div className="status-container">
          <p className="patient-row-active">
            {isEnrolled ? strings.activeStatus : strings.notEnrolledStatus}
          </p>
        </div>
        <div className="day-container">
          <p className="patient-row-days">
            {isEnrolled ? moment().diff( moment(patient.get('createdAt')).tz(patient.get('createdAtTZ')).startOf('day'), 'days') + 1 : null}
          </p>
        </div>
        <Link to={`/patients/${patientId}`}>
          <img src={nextArrow}
               className={isEnrolled ? "next-arrow" : "next-arrow-hidden"}/>
        </Link>
      </div>
    );
  }

  renderDoc = () => {
    const doc = this.props.user;
    const name = doc && ( doc.get('firstName') + ' ' + doc.get('lastName') );
    return (
      <div style={styles.docContainer}
           onClick={() => this.setState({ showProfileOptions: !this.state.showProfileOptions })}>
        <div>
          <p style={{ ...styles.zeroMargin, ...fonts.mainTitle }}>
            {name}
          </p>
          <p style={{ ...styles.zeroMargin, ...fonts.description }}>
            {doc && doc.get('emailAddress')}
          </p>
        </div>
        <img src={photoPlaceholder}
             style={styles.profilePic}/>
        {this.state.showProfileOptions ? (
          <div style={styles.opts}>
            <img src={profileOptsBg}
                 style={styles.optsBg} />
            <p onClick={this.props.onLogout} style={styles.logoutBtn}>{strings.logoutBtn}</p>
          </div>
        ) : null}
      </div>
    );
  };
  
  renderTab(title) {
    return (
      <div className="tab">
        <p className="tab-label">
          {title}
        </p>
        <div className="tab-underline" />
      </div>
    );
  }

  renderListHeader() {
    return (
      <div className="col-desc">
        <div className="name-container">
          {this.renderHeaderLabel(strings.headerNameCol)}
        </div>
        <div className="status-container">
          {this.renderHeaderLabel(strings.headerStatusCol)}
        </div>
        <div className="day-container">
          {this.renderHeaderLabel(strings.headerDayCol)}
        </div>
        <img src={nextArrow}
             className="next-arrow-hidden"/>
      </div>
    );
  }

  renderHeaderLabel(text) {
    return <p className="col-label">{text.toUpperCase()}</p>;
  }
}



// WEBPACK FOOTER //
// ./src/components/patients.js